var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircles({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 40,
    viewBox: "0 0 80 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 23.3333C17 23.3333 20 20.3333 20 16.6667C20 13 17 10 13.3333 10C9.66667 10 6.66667 13 6.66667 16.6667C6.66667 20.3333 9.66667 23.3333 13.3333 23.3333ZM17.1 27C15.8667 26.8 14.6333 26.6667 13.3333 26.6667C10.0333 26.6667 6.9 27.3667 4.06667 28.6C1.6 29.6667 0 32.0667 0 34.7667V40H15V34.6333C15 31.8667 15.7667 29.2667 17.1 27ZM66.6667 23.3333C70.3333 23.3333 73.3333 20.3333 73.3333 16.6667C73.3333 13 70.3333 10 66.6667 10C63 10 60 13 60 16.6667C60 20.3333 63 23.3333 66.6667 23.3333ZM80 34.7667C80 32.0667 78.4 29.6667 75.9333 28.6C73.1 27.3667 69.9667 26.6667 66.6667 26.6667C65.3667 26.6667 64.1333 26.8 62.9 27C64.2333 29.2667 65 31.8667 65 34.6333V40H80V34.7667ZM54.1333 25.5C50.2333 23.7667 45.4333 22.5 40 22.5C34.5667 22.5 29.7667 23.8 25.8667 25.5C22.2667 27.1 20 30.7 20 34.6333V40H60V34.6333C60 30.7 57.7333 27.1 54.1333 25.5ZM26.9 33.3333C27.2 32.5667 27.3333 32.0333 29.9333 31.0333C33.1667 29.7667 36.5667 29.1667 40 29.1667C43.4333 29.1667 46.8333 29.7667 50.0667 31.0333C52.6333 32.0333 52.7667 32.5667 53.1 33.3333H26.9ZM40 6.66667C41.8333 6.66667 43.3333 8.16667 43.3333 10C43.3333 11.8333 41.8333 13.3333 40 13.3333C38.1667 13.3333 36.6667 11.8333 36.6667 10C36.6667 8.16667 38.1667 6.66667 40 6.66667ZM40 0C34.4667 0 30 4.46667 30 10C30 15.5333 34.4667 20 40 20C45.5333 20 50 15.5333 50 10C50 4.46667 45.5333 0 40 0Z",
    fill: "url(#paint0_linear_441_287)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_441_287",
    x1: 3.26733,
    y1: 20,
    x2: 76.4356,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC93FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CA7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircles);
export default __webpack_public_path__ + "static/media/circles.18db7c39236470ef34989d4f329f9d32.svg";
export { ForwardRef as ReactComponent };